import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { Route } from 'react-router-dom'
import { ConnectedRouter } from 'react-router-redux'
import { store, history } from './store/configureStore'
import registerServiceWorker from './registerServiceWorker'

import SvgCollections from './SvgCollections'

import App from './App'

import './assets/scss/app.css'
import './assets/css/main.css'
import './assets/css/companyClientLandingPage.css'
import './assets/css/company.css'
import './assets/css/companydark.css'
import './assets/css/profile.css'

import Raven from 'raven-js';

Raven.config('https://76c7be7a2f764b12b187e613acc8242f@sentry.io/1196887').install()

const AppLayout = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
        <Route path="/" component={ App } />
    </ConnectedRouter>
  </Provider>
)

render(<AppLayout />, document.getElementById('root'))

if (module.hot) {
  module.hot.accept('./App', () => {
    render(<AppLayout />, document.getElementById('root'))
  })
}

// Render SVG's
render(<SvgCollections />, document.getElementById('svg'));

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js